<mat-chip-set *ngIf="tags.length" aria-label="Tags" class="small">
  <mat-chip
    class="small tag-chip"
    [ngClass]="{ 'tag-chip-amendment': t.toLowerCase().includes('amendment') }"
    *ngFor="let t of tags"
    [disabled]="disabled"
    [removable]="!disabled"
    (removed)="remove(t)"
  >
    {{ t }}

    <button
      matChipRemove
      *ngIf="!disabled"
      type="button"
      aria-label="Remove tag"
    >
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
</mat-chip-set>
